// extracted by mini-css-extract-plugin
module.exports = {"root":"LanePlacement_root__OfY00","switchAnimation":"LanePlacement_switchAnimation__3Gs_n","placementHover":"LanePlacement_placementHover__1VqAl"};